var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',{staticClass:"m-b-10 m-b-md-0",attrs:{"prepend":"Cant para mostrar:"}},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Cantidad de resultados para mostrar"},model:{value:(_vm.cantidad_resultados),callback:function ($$v) {_vm.cantidad_resultados=$$v},expression:"cantidad_resultados"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }